import { set } from 'cerebral/operators';
import { state, props } from 'cerebral/tags';

import resetScroll from '../actions/resetScroll';
import setBodyClass from '../actions/setBodyClass';
import trackPageView from '../actions/trackPageView';

export default [
    set(state`app.currentPage`, props`page`),
    set(state`app.currentSection`, null),
    setBodyClass,
    resetScroll,
    trackPageView,
];



// WEBPACK FOOTER //
// ./src/store/modules/app/signals/pageRouted.js